import { gql } from "@apollo/client";

import RunActionFieldsFragment from "components/Run/elements/ActionButtons/ActionFragment";

export const GET_RUN_V3 = gql`
  query GetRunV3($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        ...RunActionFieldsFragment
        branch
        createdAt
        changesV3(input: {}) {
          resources {
            address
            previousAddress
            metadata {
              type
            }
          }
        }
        delta {
          addCount
          changeCount
          deleteCount
          resources
          importCount
          forgetCount
          moveCount
        }
        expired
        isMostRecent
        supportsDetailedResources
        title
        type
      }
    }
  }
  ${RunActionFieldsFragment}
`;
